var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading_wrapper"},[_c('LoadingIndicator',{staticClass:"primary big"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }